<template>
  <div  style="text-align: center;">
    <div v-if="showFlag">
      <el-row style="margin-bottom: 15px;margin-top: 25%">
        <el-col span="8" style="text-align:right ">企业名称：</el-col>
        <el-col span="14" :offset="1" style="text-align: left">{{qymc}}</el-col>
      </el-row>
      <el-row style="margin-bottom: 15px">
        <el-col span="8" style="text-align:right ">信用代码：</el-col>
        <el-col span="14" :offset="1" style="text-align: left">{{tyshxydm}}</el-col>
      </el-row>
      <!--    <el-row style="margin-bottom: 15px">-->
      <!--      <el-col span="8" style="text-align:right ">法人：</el-col>-->
      <!--      <el-col span="14" :offset="1" style="text-align: left">{{fr}}</el-col>-->
      <!--    </el-row>-->
      <!--    <el-row style="margin-bottom: 15px">-->
      <!--      <el-col span="8" style="text-align:right ">电话：</el-col>-->
      <!--      <el-col span="14" :offset="1" style="text-align: left">{{dhhm}}</el-col>-->
      <!--    </el-row>-->
      <el-button>
        <a :href="url">企业服务通道</a>
      </el-button>
    </div>
    <div v-else >
      <div style="margin-top: 25%;font-size: 20px;color: orange">未找到该企业用户信息!!!</div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        url:'http://36.133.218.216:8000/loginMobile?dhhm=',
        qymc: '',
        tyshxydm: '',
        fr: '叶容根',
        dhhm: '',
        showFlag:true,
      }
    },
    created() {
      // this.dhhm = this.getUrlParam("dhhm")
      this.tyshxydm = this.getUrlParam("tyshxydm")
    },
    mounted() {
      this.selectOneByTyshxydm()
    },
    methods: {
      getUrlParam(paraName) {
        let url = document.location.toString()
        let arrObj = url.split('?')
        let arrPara = arrObj[1].split('&')
        let arr
        for (let i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split('=')
          if (arr != null && arr[0] == paraName) {
            return arr[1]
          }
        }
        return ''
      },
      selectOneByTyshxydm(){
        let params = {
          "tyshxydm":this.tyshxydm
        }
        this.$httpApi
          .post(`/dev-api/enterprise/baseInfo/selectOneByTyshxydm`, params)
          .then((res) => {
            if(res.data != null){
              this.qymc =  res.data.name
              this.fr =  res.data.frdb
              this.url = this.url + res.data.phone
            }else{
              this.showFlag = false
              this.$message.success("未找到该企业用户信息");
            }
          })
      },
    }
  }
</script>
